import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { API_PATHS } from "../../service/api";
import {
  CalendarSettingsParams,
  CalendarSettingsResponse,
} from "../../types/calendarSettings";

export const getCalendarSettings = createAsyncThunk(
  "getCalendarSettings",
  async (params: CalendarSettingsParams) => {
    const response = await api.get<CalendarSettingsResponse>(
      `${API_PATHS.getCalendarSettings}?filterId=${params.filterId}`,
    );
    return response.data;
  },
);
